import styled from 'styled-components/macro'
import { em } from '../../utils/styles'
import MainWrapper from '../MainWrapper'

const MainBannerWrapper = styled(MainWrapper)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: ${em(48)};
  padding-bottom: ${em(48)};
`

export default MainBannerWrapper
